import React from 'react';
import classnames from 'classnames';
import ProductInfo from '../../../../../../common/components/ProductInfo';

const HardwareList = ({hardwareList, className}) => {
    const mainClassName = classnames('product-list', className);
    return (
        <div className={mainClassName}>
            {
                hardwareList.map((hardware, i) => (
                    <div className="product clearfix" key={i}>
                        <ProductInfo subscription={hardware} className="col-xs-12" />
                    </div>
                ))
            }
        </div>)
};

export default HardwareList;